export const AO_PACKAGE_DETAILS_REQUEST = 'AO_PACKAGE_DETAILS_REQUEST';
export const AO_PACKAGE_DETAILS_SUCCESS = 'AO_PACKAGE_DETAILS_SUCCESS';
export const AO_PACKAGE_DETAILS_FAILURE = 'AO_PACKAGE_DETAILS_FAILURE';
export const sendAddOrderPackageDetailsSuccess = (payload) => ({
    type: AO_PACKAGE_DETAILS_SUCCESS,
    payload,
});
export const sendAddOrderPackageDetailsRequest = (payload) => ({
    type: AO_PACKAGE_DETAILS_REQUEST,
    payload,
});
export const sendAddOrderPackageDetailsFailure = (payload) => ({
    type: AO_PACKAGE_DETAILS_FAILURE,
    payload,
});
